<template>
  <div class="collect_box">
    <div class="main_header">
      <div class="main_header_text">历史记录</div>
      <div class="main_header_icon" @click="closemin"></div>
    </div>
    <div class="h_header">
      <div class="selectKeys">
        <div class="selectKey" :class="key == 1 ? 'selectKey_active' : ''" @click="selectKey(1)">全部</div>
        <div class="selectKey" :class="key == 2 ? 'selectKey_active' : ''" @click="selectKey(2)">文件</div>
        <div class="selectKey" :class="key == 3 ? 'selectKey_active' : ''" @click="selectKey(3)">图片/视频</div>
      </div>
      <div class="search">
        <div class="search-bar">
          <a-input v-model="searchValue" placeholder="搜索" allow-clear @search="onSearch">
            <span slot="prefix" class="search-prefix-icon"></span>
          </a-input>
        </div>
        <!-- 右侧只露日历图标：透明的时间范围选择器盖在图标上，点击即弹出日期面板 -->
        <div class="search-range">
          <span v-if="dateRangeLabel" class="range-text">{{ dateRangeLabel }}<span class="range-clear" @click.stop="clearDateRange">×</span></span>
          <img class="range-calendar" src="~@/assets/date.png" />
          <a-range-picker class="range-cover" :locale="locale" :placeholder="['开始时间', '结束时间']" @change="onChange" />
        </div>
      </div>
    </div>
    <div id="list_message" class="list" @scroll="onListScroll">
      <a-spin v-if="loading" style="display: block; margin: 20px auto;" />
      <div v-if="!loading && rawList.length === 0" class="loadMoreh">暂无聊天记录</div>
      <div v-if="!loading && rawList.length > 0 && filteredList.length === 0" class="loadMoreh">当前筛选条件下暂无记录</div>
      <template v-for="node in renderNodes">
        <!-- 日期变化时插入居中日期分隔(10-13) -->
        <div v-if="node.type === 'divider'" :key="'d' + node.key" class="date-divider">{{ node.label }}</div>
        <!-- 普通消息(文本/语音/文件/兜底卡片) -->
        <div v-else-if="node.type === 'item'" :key="String(node.item.id)" class="item-from">
          <!-- 文件行的 时间/发送人 在右侧列，顶部不再重复展示 -->
          <div v-if="renderType(node.item) !== 'file'" class="item-header">
            <div class="item-header-text">{{ getSenderLabel(node.item) }}</div>
            <div class="item-header-time">{{ dateFormat('HH:mm', node.item.createTime) }}</div>
          </div>
          <!-- 文本：无气泡纯文本 -->
          <div v-if="renderType(node.item) === 'txt'" class="item-body item-body-text">{{ node.item.messageMsg }}</div>
          <!-- 语音：圆角条 + 条外时长 -->
          <div v-else-if="renderType(node.item) === 'audio'" class="item-body item-body-audio">
            <div class="audio-bar" :class="node.item.belong ? 'audio-bar-self' : ''">
              <span class="audio-bar-i"></span><span class="audio-bar-i"></span><span class="audio-bar-i"></span><span class="audio-bar-i"></span>
            </div>
            <span class="audio-length">{{ node.item.messageAudioLength || 0 }}″</span>
          </div>
          <!-- 文件：图标 + (标题 / 大小+下载) + 右侧(时间+发送人)，统一靠左 -->
          <div v-else-if="renderType(node.item) === 'file'" class="item-body file-row">
            <img class="file-icon" :src="getFileIcon(node.item.messageFileName)" />
            <div class="file-mid">
              <div class="file-name" :title="node.item.messageFileName">{{ node.item.messageFileName }}</div>
              <div class="file-sub">
                <span class="file-size">{{ fileSizeFormat(node.item.messageFileLength) }}</span>
                <span v-down="node.item" class="file-download">下载</span>
              </div>
            </div>
            <div class="file-right">
              <div class="file-time">{{ dateFormat('HH:mm', node.item.createTime) }}</div>
              <div class="file-sender">{{ getSenderLabel(node.item) }}</div>
            </div>
          </div>
          <!-- 图片：缩略图，点击放大预览(全部 tab 逐条展示) -->
          <div v-else-if="renderType(node.item) === 'img'" class="item-body">
            <img class="img-thumb" :src="node.item.messageUrl" loading="lazy" @click="openPreview('img', node.item.messageUrl)" />
          </div>
          <!-- 视频：内联播放(全部 tab 逐条展示) -->
          <div v-else-if="renderType(node.item) === 'video'" class="item-body">
            <video class="video-thumb" :src="node.item.messageUrl" controls preload="metadata"></video>
          </div>
          <!-- 其余类型(自定义卡片/撤回等)：复用聊天渲染 -->
          <div v-else class="item-body">
            <messageBodyList :item="node.item" />
          </div>
        </div>
        <!-- 图片/视频组：同一日期内横向排列自动换行；不显示发送人，时间在缩略图下方；点击放大预览 -->
        <div v-else :key="'m' + node.key" class="item-from media-group">
          <div v-for="m in node.items" :key="String(m.item.id)" class="media-cell">
            <img v-if="m.kind === 'img'" :src="m.item.messageUrl" class="media-thumb" loading="lazy" @click="openPreview('img', m.item.messageUrl)" />
            <div v-else class="media-video-wrap" @click="openPreview('video', m.item.messageUrl)">
              <video class="media-thumb" :src="m.item.messageUrl" preload="metadata"></video>
              <span class="media-video-badge"></span>
            </div>
            <div class="media-time">{{ m.time }}</div>
          </div>
        </div>
      </template>
      <div v-if="!allLoaded" class="loadMore" @click="loadMore">{{ loading ? '加载中...' : '点击加载更多' }}</div>
      <div v-else-if="rawList.length > 0" class="loadMore">没有更多了</div>
    </div>
    <!-- 图片/视频放大预览：居中弹窗，点遮罩或右上角 × 关闭 -->
    <a-modal :visible="preview.visible" :footer="null" width="860px" :destroy-on-close="true" title="" class="media-preview-modal" @cancel="closePreview">
      <img v-if="preview.kind === 'img'" class="media-preview-img" :src="preview.url" />
      <video v-else class="media-preview-video" :src="preview.url" controls autoplay></video>
    </a-modal>
  </div>
</template>
<script>
import dateFormat from '@/utils/dateFormater'
import fileSizeFormat from '@/utils/fileSizeFormat'
import messageBodyList from '@/components/messageBodyList/messageBodyList.vue'
export default {
  components: {
    messageBodyList
  },
  props: {
    uid: {
      type: String,
      default: ''
    },
    chatType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      key: 1,
      searchValue: '',
      dateRange: [],
      rawList: [],
      page: 0,
      pageSize: 30,
      loading: false,
      allLoaded: false,
      dateFormat: dateFormat,
      fileSizeFormat: fileSizeFormat,
      preview: {
        visible: false,
        kind: 'img',
        url: ''
      },
    };
  },
  computed: {
    //客户端过滤：类型 tab + 关键字(消息文本/文件名) + 时间范围，实时生效
    filteredList() {
      const kw = (this.searchValue || '').trim()
      const range = (this.dateRange || []).filter(x => !!x)
      const start = range.length === 2 ? new Date(range[0] + ' 00:00:00').getTime() : null
      const end = range.length === 2 ? new Date(range[1] + ' 23:59:59').getTime() : null
      return this.rawList.filter(item => {
        if (this.key == 2 && item.messageType != 'file') {
          return false
        }
        if (this.key == 3 && item.messageType != 'img' && item.messageType != 'video') {
          return false
        }
        if (kw) {
          const msg = (item.messageMsg || '').toString()
          const name = (item.messageFileName || '').toString()
          if (msg.indexOf(kw) < 0 && name.indexOf(kw) < 0) {
            return false
          }
        }
        if (start !== null || end !== null) {
          const t = new Date(item.createTime).getTime()
          if (isNaN(t)) {
            return false
          }
          if (start !== null && t < start) {
            return false
          }
          if (end !== null && t > end) {
            return false
          }
        }
        return true
      })
    },
    //已选时间范围的短展示(MM-DD ~ MM-DD)
    dateRangeLabel() {
      const range = (this.dateRange || []).filter(x => !!x)
      if (range.length !== 2) {
        return ''
      }
      return range[0].slice(5) + '~' + range[1].slice(5)
    },
    //渲染节点：日期分隔 / 普通消息 / 媒体组。
    //横向图墙只用于「图片/视频」tab；「全部」tab 图片视频按普通消息逐条展示
    renderNodes() {
      const nodes = []
      let lastDate = null
      let mediaGroup = null
      const mediaTab = this.key == 3
      this.filteredList.forEach(item => {
        const d = this.dateLabel(item.createTime)
        if (d !== lastDate) {
          nodes.push({ type: 'divider', label: d, key: String(item.id) })
          lastDate = d
          mediaGroup = null
        }
        const kind = mediaTab ? this.mediaKind(item) : null
        if (kind) {
          if (!mediaGroup) {
            mediaGroup = { type: 'media-group', items: [], key: String(item.id) }
            nodes.push(mediaGroup)
          }
          mediaGroup.items.push({ item, kind, time: this.dateFormat('HH:mm', item.createTime) })
          return
        }
        mediaGroup = null
        nodes.push({ type: 'item', item })
      })
      return nodes
    },
  },
  watch: {
    uid: function () {
      this.initdata()
    },
    chatType: function () {
      this.initdata()
    }
  },
  mounted() {
    this.initdata()
  },
  methods: {
    closemin() {
      this.$emit('closemin')
    },
    selectKey(e) {
      this.key = e
    },
    onSearch() {},
    onChange(dates, dateStrings) {
      this.dateRange = dateStrings || []
    },
    clearDateRange() {
      this.dateRange = []
    },
    //滚动到顶部自动加载更早的消息(与点击“加载更多”等效)
    onListScroll(e) {
      if (e.target && e.target.scrollTop <= 2) {
        this.loadMore()
      }
    },
    async loadMore() {
      await this.loadPage()
    },
    async initdata() {
      this.page = 0
      this.rawList = []
      this.allLoaded = false
      await this.loadPage()
    },
    //数据源与主聊天窗一致：按会话分页拉取(netty-im)，消息渲染复用 messageBodyList
    async loadPage() {
      if (this.loading || this.allLoaded || !this.uid) {
        return
      }
      this.loading = true
      try {
        const res = await this.$ImSdk.getMessagePage({
          messageSessionId: this.uid,
          type: this.chatType,
          pageNo: this.page + 1,
          pageSize: this.pageSize,
        })
        const list = res || []
        const seen = new Set(this.rawList.map(m => String(m.id)))
        list.forEach(item => {
          if (item && item.id != null && !seen.has(String(item.id))) {
            this.rawList.unshift(item)
            seen.add(String(item.id))
          }
        })
        this.allLoaded = list.length < this.pageSize
        this.page++
      } catch (e) {
        console.log('历史记录加载失败', e)
      }
      this.loading = false
    },
    //发送方名称：members 里按 messageFrom 匹配昵称
    getSenderName(item) {
      let name = ''
      ;(item.members || []).forEach(m => {
        if (item.messageFrom == m.id && m.nickname) {
          name = m.nickname
        }
      })
      return name || '未知'
    },
    //设计稿口径：自己发的显示「我」，其余显示昵称
    getSenderLabel(item) {
      return item.belong ? '我' : this.getSenderName(item)
    },
    dateLabel(time) {
      const d = new Date(time)
      if (isNaN(d.getTime())) {
        return ''
      }
      const m = d.getMonth() + 1
      const day = d.getDate()
      return m + '-' + (day < 10 ? '0' + day : day)
    },
    //图片/视频归类(撤回消息不算)，其余返回 null 走普通渲染
    mediaKind(item) {
      if (item.status == 2) {
        return null
      }
      if (item.messageType === 'img') {
        return 'img'
      }
      if (item.messageType === 'video') {
        return 'video'
      }
      return null
    },
    //历史列表简化渲染的类型：txt/audio/img/video/file 自绘，其余回退聊天组件
    renderType(item) {
      if (item.status == 2) {
        return 'fallback'
      }
      if (item.messageType === 'txt') {
        return 'txt'
      }
      if (item.messageType === 'audio') {
        return 'audio'
      }
      if (item.messageType === 'img') {
        return 'img'
      }
      if (item.messageType === 'video') {
        return 'video'
      }
      if (item.messageType === 'file') {
        return 'file'
      }
      return 'fallback'
    },
    //文件类型图标：与聊天窗 fileMessage 同一套 CDN 图标，未识别类型用本地通用图标
    getFileIcon(name) {
      const n = (name || '').toString()
      const ext = n.substring(n.lastIndexOf('.') + 1)
      const map = {
        zip: 'zip', ZIP: 'zip',
        doc: 'word', docx: 'word', DOC: 'word', DOCX: 'word',
        xls: 'xls', xlsx: 'xls', XLS: 'xls', XLSX: 'xls',
        txt: 'txt', TXT: 'txt',
        pdf: 'pdf', PDF: 'pdf',
        ppt: 'ppt', pptx: 'ppt', PPT: 'ppt', PPTX: 'ppt',
        dwg: 'cad', dxf: 'cad', DWG: 'cad', DXF: 'cad',
        png: 'png', jpg: 'jpg',
      }
      const icon = map[ext]
      if (icon) {
        return 'https://cdn.binliyoujia.com/static/message/message-img/' + icon + '.png'
      }
      return require('@/assets/fileicon.png')
    },
    //放大预览：图片展示原图，视频用大窗口自动播放
    openPreview(kind, url) {
      if (!url) {
        return
      }
      this.preview = { visible: true, kind, url }
    },
    closePreview() {
      //url 一并置空，让 <video> 卸载后停止播放
      this.preview.visible = false
      this.preview.url = ''
    },
  },

}
</script>
<style lang="less" scoped>
.collect_box {
    padding-top: 0px;
}
.main_header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.main_header_text{
    font-family: PingFangSCMedium-Medium;
    font-size: 16px;
    color: #222222;
}
.main_header_icon{
    width:16px;
    height:16px;
    background-image:url("~@/assets/main-close.png");
    background-size:100%;
    cursor: pointer;
}
.h_header{
    margin-top: 14px;
    padding-left: 10px;
    padding-right: 10px;
}
.selectKeys{
    display:flex;
    margin-top: 6px;
}
.selectKey{
    margin-right:32px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #222222;
    cursor: pointer;
    padding-bottom: 4px;
}
.selectKey_active{
    color: #ED2616;
}
.search{
    display:flex;
    align-items: center;
    margin-top:14px;
}
// 圆角灰底搜索条
.search-bar{
    flex: 1;
    height: 32px;
    background: #F5F5F5;
    border-radius: 16px;
    display: flex;
    align-items: center;
    overflow: hidden;
    /deep/ .ant-input{
        background: transparent;
        border: none;
        box-shadow: none;
        height: 30px;
        font-size: 12px;
    }
    /deep/ .ant-input-affix-wrapper .ant-input:not(:last-child){
        padding-left: 30px;
    }
    /deep/ .ant-input-prefix{
        left: 10px;
        color: #999999;
    }
}
.search-prefix-icon{
    display: inline-block;
    width: 14px;
    height: 14px;
    background-image: url("~@/assets/seach.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
// 右侧日历图标：透明 range-picker 盖在上面，点击弹出日期面板；已选范围显示短文本
.search-range{
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    margin-left: 8px;
    padding: 0 10px;
    background: #F5F5F5;
    border-radius: 16px;
}
.range-calendar{
    width: 16px;
    height: 16px;
    display: block;
}
.range-text{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    margin-right: 6px;
    white-space: nowrap;
}
.range-clear{
    margin-left: 4px;
    color: #999999;
    cursor: pointer;
    font-size: 14px;
    &:hover{
        color: #666666;
    }
}
.range-cover{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    /deep/ .ant-calendar-picker-input{
        border: none;
        padding: 0;
        height: 32px;
    }
}
.list{
    height:350px;
    margin-top:14px;
    text-align:left;
    overflow-y:auto;
    padding: 0 10px;
}
.list::-webkit-scrollbar{
  background-color: #fff;
  width: 3px;
}
.list::-webkit-scrollbar-thumb {
  border-radius: 20px;
  box-shadow: inset 0 0 2px rgba(0,0,0,0.1);
  background: rgba(0,0,0,0.1);
}
.date-divider{
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #BBBBBB;
    margin: 12px 0 4px;
}
.item-from{
    margin-top:12px;
}
.item-header{
    display:flex;
    align-items: baseline;
}
.item-body{
    margin-top:6px;
}
.item-header-text{
    margin-right:8px;
    font-family: PingFangSC-Regular;
    font-size: 11px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
    color: #666666;
}
.item-header-time{
    font-family: PingFangSC-Regular;
    font-size: 10px;
    font-weight: normal;
    line-height: 14px;
    letter-spacing: 0px;
    color: #999999;
}
// 纯文本(无气泡)
.item-body-text{
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #222222;
    line-height: 20px;
    max-width: 90%;
    word-break: break-all;
}
// 语音条
.item-body-audio{
    display: flex;
    align-items: center;
}
.audio-bar{
    width: 120px;
    height: 34px;
    border-radius: 8px;
    background: #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
}
.audio-bar-self{
    background: #FBEDDC;
}
.audio-bar-i{
    display: inline-block;
    width: 2px;
    border-radius: 2px;
    background: #999999;
    &:nth-child(1){ height: 8px; }
    &:nth-child(2){ height: 14px; }
    &:nth-child(3){ height: 10px; }
    &:nth-child(4){ height: 15px; }
}
.audio-length{
    margin-left: 8px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
}
// 图片/视频组：仅「图片/视频」tab；同一日期段内横向排列自动换行；不显示发送人，时间在缩略图下
.media-group{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.media-cell{
    width: 104px;
}
.media-thumb{
    width: 104px;
    height: 104px;
    object-fit: cover;
    border-radius: 4px;
    display: block;
    background: #f2f2f2;
}
.media-video-wrap{
    position: relative;
    cursor: pointer;
}
.media-video-badge{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 0;
    height: 0;
    margin: -10px 0 0 -7px;
    border-left: 14px solid rgba(255,255,255,0.9);
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    pointer-events: none;
}
.media-time{
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #999999;
    line-height: 14px;
    margin-top: 2px;
}
// 「全部」tab 逐条展示的图片/视频
.img-thumb{
    max-width: 140px;
    max-height: 140px;
    border-radius: 4px;
    cursor: pointer;
    display: block;
}
.video-thumb{
    max-width: 180px;
    border-radius: 4px;
    display: block;
}
// 放大预览弹窗
.media-preview-modal{
    /deep/ .ant-modal-body{
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.media-preview-img{
    max-width: 100%;
    max-height: 70vh;
    display: block;
    margin: 0 auto;
}
.media-preview-video{
    max-width: 100%;
    max-height: 70vh;
    display: block;
    margin: 0 auto;
    outline: none;
}
// 文件行：图标 + (标题 / 大小+下载) + 右侧(时间+发送人)，统一靠左
.file-row{
    display: flex;
    align-items: center;
    background: #F7F7F7;
    border-radius: 8px;
    padding: 10px;
    max-width: 90%;
}
.file-icon{
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    display: block;
}
.file-mid{
    flex: 1;
    min-width: 0;
    margin-left: 10px;
}
.file-name{
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #222222;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.file-sub{
    display: flex;
    align-items: center;
    margin-top: 4px;
}
.file-size{
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #999999;
}
.file-download{
    margin-left: 12px;
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #ED2616;
    cursor: pointer;
    display: flex;
    align-items: center;
    img{
        width: 12px;
        height: 12px;
        margin-right: 3px;
    }
    &:hover{
        text-decoration: underline;
    }
}
.file-right{
    flex-shrink: 0;
    margin-left: 12px;
    text-align: right;
}
.file-time{
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #999999;
    line-height: 14px;
}
.file-sender{
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #666666;
    line-height: 16px;
    margin-top: 2px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
// 兜底复用聊天渲染的卡片(自定义消息等)：去掉聊天样式自带的头像/昵称/时间与左右分布，
// 统一靠左——这些覆盖写在历史记录自己的 scoped 样式里，只影响本弹层，不碰聊天窗
.item-body{
    /deep/ .user-header{ display: none; }
    /deep/ .text-name,
    /deep/ .text-name-my{ display: none; }
    /deep/ .message-time{ display: none; }
    /deep/ .message-body-my{ justify-content: flex-start; margin-right: 0; }
}
.loadMore{
  font-size: 12px;
  color: #999999;
  margin-top: 10px;
  cursor: pointer;
  text-align: center;
}
.loadMoreh{
  font-size: 12px;
  color: #bbbbbb;
  margin-top: 10px;
  text-align: center;
}
.empty-tip{
  text-align:center;
  color:#999999;
  font-size:12px;
  padding:20px 0;
}
</style>
